import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) { toast.error("Fyll ut begge felt"); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      localStorage.setItem("admin_token", res.data.token);
      localStorage.setItem("admin_user", JSON.stringify(res.data.admin));
      toast.success("Logget inn!");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Innlogging feilet");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <h1 data-testid="admin-login-title" className="font-serif text-4xl tracking-tight mb-2">Imassasje</h1>
          <p className="text-muted-foreground text-sm">Admin innlogging</p>
        </div>
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="flex items-center gap-2 text-sm text-muted-foreground mb-2"><User size={14} /> Brukernavn</label>
            <Input
              data-testid="admin-username-input"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="admin"
              className="bg-transparent border-b-2 border-primary/20 rounded-none px-0 focus-visible:ring-0 focus-visible:border-primary h-12 text-base"
            />
          </div>
          <div>
            <label className="flex items-center gap-2 text-sm text-muted-foreground mb-2"><Lock size={14} /> Passord</label>
            <Input
              data-testid="admin-password-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="********"
              className="bg-transparent border-b-2 border-primary/20 rounded-none px-0 focus-visible:ring-0 focus-visible:border-primary h-12 text-base"
            />
          </div>
          <Button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-base transition-all hover:scale-105 w-full"
          >
            {loading ? "Logger inn..." : "Logg inn"}
          </Button>
        </form>
        <p className="text-center mt-6 text-sm text-muted-foreground">
          Ny admin?{" "}
          <Link to="/admin/register" data-testid="login-register-link" className="text-foreground hover:underline">Registrer deg</Link>
        </p>
      </div>
    </div>
  );
}
